// Debug logging — silenced in production builds.
//
// Use `dlog`/`dwarn`/`dinfo` instead of `console.log`/`warn`/`info` for
// any debug/diagnostic output. Errors (console.error) should stay as-is
// — those signal real problems and should always surface.
//
// In development (`npm start`) these forward to console.* with the
// original call site preserved. In production (`npm run build`) they
// no-op, keeping the browser console quiet for users.

const DEBUG = process.env.NODE_ENV !== 'production';

const noop = () => {};

export const dlog = DEBUG ? console.log.bind(console) : noop;
export const dwarn = DEBUG ? console.warn.bind(console) : noop;
export const dinfo = DEBUG ? console.info.bind(console) : noop;
